/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { InvestmentStatusValues, PaymentMethodType } from '../types/utils';
import { InvestmentStatusChangeLogEntry } from './investment-status-change-log-entry-model';
import { PaymentMethodID } from './payment-method-model';
import { SaleID } from './sale-model';
import { UserID } from './user-model';

export type InvestmentID = string;

export class Investment {
	id: InvestmentID = ''

	amountShares: number = 0

	createdAt?: Date

	investingForThemselves?: boolean

	paymentMethodId?: PaymentMethodID

	paymentMethodType: PaymentMethodType = PaymentMethodType.WIRE_TRANSFER

	saleId: SaleID = ''

	selfDisclosedAvailableCash?: boolean

	selfDisclosedMonthlyNetSalary?: boolean

	status?: InvestmentStatusValues

	statusChangeLog?: Array<InvestmentStatusChangeLogEntry>

	updatedAt?: Date

	userId: UserID = ''

	static getMaxUserInvestmentPerSale() : number {
		return 25000;
	}

	static getSelfDisclosureInfo() : any {
		return { availableCashDisclosureLimit: 1000, monthlyNetSalaryDisclosureLimit: 10000, }
	}
}